import request from '@/services/base/request';
import ServicesEnum from '@/services/_helpers/_types';
export default {
    getTransfersPaymentData: (data) => request(ServicesEnum.traderProfile, '/withdraw/payment_data/', 'get', data),
    getInnerTransfersData: (data) => request(ServicesEnum.traderProfile, `/withdraw/inner_transfer_history/?${data.query}`, 'get', data.payload),
    getOuterTransfersData: (data) => request(ServicesEnum.traderProfile, `/withdraw/history/?${data.query}`, 'get', data.payload),
    doOutboundTransfer: (data) => request(ServicesEnum.traderProfile, `/withdraw/transfer/${data.sessionId}/`, 'post', data.payload),
    getBonusesHistory: (data) => request(ServicesEnum.traderProfile, '/withdraw/bonus_history/', 'get', data),
    getBetweenExchangesData: (data) => request(ServicesEnum.traderProfile, `/exchanges/transaction/history/${data.query}`, 'get', null)
};
